
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.616 16a8 8 0 100-16.001 8 8 0 000 16.001zm3.782-7.531a.75.75 0 01-1.06 1.06L8.62 6.808 5.901 9.53a.75.75 0 01-1.06-1.06l3.244-3.25a.747.747 0 011.06 0l3.253 3.25z","fill":"#282828"}})])
          )
        }
      }
    